import { createSelector } from 'reselect';
import { bookingFilterSelector } from './bookingFilter';

export const moduleBookingFilterSelector = createSelector(
    bookingFilterSelector,
    ({ modules }) => modules,
);
